import { render, staticRenderFns } from "./DailyActivitiesAndNews.vue?vue&type=template&id=61ec356d&"
import script from "./DailyActivitiesAndNews.vue?vue&type=script&lang=js&"
export * from "./DailyActivitiesAndNews.vue?vue&type=script&lang=js&"
import style0 from "./DailyActivitiesAndNews.vue?vue&type=style&index=0&lang=less&"
import style1 from "./DailyActivitiesAndNews.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports